var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("settings.tab.sites"))),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
        attrs: {
          type: "checkbox",
          disabled:
            !_vm.formOptions.hasSettingUpdateAccess || _vm.formOptions.readonly,
        },
        domProps: { checked: _vm.all },
        on: {
          click: function ($event) {
            return _vm.selectAll()
          },
        },
      }),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("action.selectAll")))]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "sites" },
      _vm._l(_vm.sites, function (site, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "site",
            class: {
              light:
                _vm.keepTickSiteIds.includes(site.id) &&
                !_vm.formOptions.readonly,
            },
          },
          [
            _c("input", {
              directives: [
                { name: "hkldinput", rawName: "v-hkldinput" },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selected,
                  expression: "selected",
                },
              ],
              attrs: {
                type: "checkbox",
                disabled:
                  !_vm.formOptions.hasSettingUpdateAccess ||
                  _vm.formOptions.readonly ||
                  !_vm.clickableSiteIds.includes(site.id) ||
                  _vm.keepTickSiteIds.includes(site.id),
              },
              domProps: {
                value: site.id,
                checked: Array.isArray(_vm.selected)
                  ? _vm._i(_vm.selected, site.id) > -1
                  : _vm.selected,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.selected,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = site.id,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.selected = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.selected = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.selected = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(site.code))]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }